import React from 'react';
import './Footer.css';

// Logo
import logoDoggy from '../../assets/logos/logo_doggy_512.jpg';
import cheProfile from '../../assets/logos/che_profile.webp';

/**
 * SECCIÓN 9: FOOTER
 * Cierre limpio + puerta a crypto para curiosos
 */

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" id="footer">
      <div className="container">
        <div className="footer__content">

          {/* Logo + nombre */}
          <div className="footer__brand">
            <div className="footer__logo">
              <img src={logoDoggy} alt="DOGGY" />
            </div>
            <span className="footer__brand-name">$DOGGY</span>
          </div>

          {/* Tagline */}
          <p className="footer__tagline">
            La memecoin más grande de Latinoamérica 🇲🇽
          </p>

          {/* Social links - liquid glass pills */}
          <div className="footer__social">
            <a 
              href="https://x.com/soyeldoggy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer__social-btn"
              aria-label="X"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              Twitter
            </a>
            <a 
              href="https://chat.whatsapp.com/IkXLzYfYcWK8Ye1fIlQQI5" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer__social-btn"
              aria-label="WhatsApp"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
              </svg>
              WhatsApp
            </a>
            <a 
              href="https://t.me/SoyElDoggy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer__social-btn"
              aria-label="Telegram"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.944 0A12 12 0 1 0 24 12.056A12.014 12.014 0 0 0 11.944 0Zm5.654 8.22l-1.736 8.19c-.13.586-.48.727-.97.453l-2.68-1.974-1.293 1.244a.674.674 0 0 1-.538.263l.193-2.734 4.974-4.493c.216-.193-.047-.3-.336-.107L9.09 13.234l-2.636-.823c-.573-.18-.585-.573.12-.849l10.3-3.97c.477-.173.894.107.724.628Z"/>
              </svg>
              Telegram
            </a>
            <a 
              href="https://discord.gg/cJfja9XZ23" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer__social-btn"
              aria-label="Discord"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.095 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.095 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
              </svg>
              Discord
            </a>
          </div>

          {/* Quick nav links */}
          <div className="footer__nav">
            <a href="#que-es" className="footer__nav-link">¿Qué es $Doggy?</a>
            <span className="footer__nav-dot">·</span>
            <a href="#comunidad" className="footer__nav-link">Comunidad</a>
            <span className="footer__nav-dot">·</span>
            <a href="https://www.instagram.com/p/DRSPf1fj4fo/" target="_blank" rel="noopener noreferrer" className="footer__nav-link">Comprar</a>
          </div>

          {/* Credit */}
          <div className="footer__credit">
            <a 
              href="https://x.com/chebtcsol" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer__credit-link"
            >
              <img src={cheProfile} alt="CHE" className="footer__credit-photo" />
              <span className="footer__credit-text">
                <span className="footer__credit-check">✓</span> Página por <strong>@chebtcsol</strong>
              </span>
            </a>
          </div>

          {/* Copyright */}
          <p className="footer__copyright">© {currentYear} DOGGY</p>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
